// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Справи розслідувань» (Investigation Cases, ключ `inv`, група `legal`). */
export const investigationCasesManifest: IModuleManifest = {
  key: 'inv',
  group: 'legal',
  slug: 'investigation-cases',
  prefix: 'INV',
  name: { en: 'Investigation Cases', uk: 'Справи розслідувань' },
  entities: [
    { key: 'inv', slug: 'inv', name: { en: 'Investigation Cases', uk: 'Справи розслідувань' }, main: true },
    { key: 'investigation_witness', slug: 'investigation-witness', name: { en: 'Investigation Witnesses', uk: 'Свідки' }, main: false },
    { key: 'investigation_evidence', slug: 'investigation-evidence', name: { en: 'Investigation Evidences', uk: 'Докази' }, main: false },
    { key: 'investigation_finding', slug: 'investigation-finding', name: { en: 'Investigation Findings', uk: 'Висновки' }, main: false },
    { key: 'investigation_hearing', slug: 'investigation-hearing', name: { en: 'Investigation Hearings', uk: 'Слухання' }, main: false },
  ],
  loadState: () => import('./state/investigationCasesSlice').then((m) => m.investigationCasesSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
